import { render, staticRenderFns } from "./DialogFooter.vue?vue&type=template&id=017d2d08&scoped=true"
import script from "./DialogFooter.vue?vue&type=script&lang=js"
export * from "./DialogFooter.vue?vue&type=script&lang=js"
import style0 from "./DialogFooter.vue?vue&type=style&index=0&id=017d2d08&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "017d2d08",
  null
  
)

export default component.exports